import { useEffect, useState } from "react";

import { getSvcSettingsClient, type SettingsGroup } from "../client/svcSettings";

const LEARNER_ANIMATIONS_SETTINGS_GROUP = "learner.animations";
const ANIMATIONS_ENABLED_FIELD = "animationsEnabled";

export const getAnimationsEnabled = (groups: SettingsGroup[]): boolean => {
  const animationsGroup = groups.find(
    group => group.groupName === LEARNER_ANIMATIONS_SETTINGS_GROUP
  );
  // Animations stay on unless the tenant has explicitly turned them off.
  return animationsGroup?.values?.[ANIMATIONS_ENABLED_FIELD] !== false;
};

export function useAnimationsEnabled(tenantName: string | null | undefined) {
  const [animationsEnabled, setAnimationsEnabled] = useState(true);
  const [isLoading, setIsLoading] = useState(Boolean(tenantName));

  useEffect(() => {
    if (!tenantName) {
      setAnimationsEnabled(true);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    const load = async () => {
      try {
        const { promise } = getSvcSettingsClient().getTenantSettings(
          tenantName,
          LEARNER_ANIMATIONS_SETTINGS_GROUP
        );
        const settings = await promise;
        if (cancelled) return;

        setAnimationsEnabled(getAnimationsEnabled(settings?.groups ?? []));
      } catch (error) {
        console.error("Error fetching animations setting:", error);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [tenantName]);

  return { animationsEnabled, isLoading };
}
